<template>
  <div>
    <image-control :image-id="form.image_id"
                   v-model="form.image_id"
                   @event="form.listen(form, $event)"></image-control>

    <form-group type="select"
                id="company"
                label="Show On Company Website</small>"
                v-model="form.company"
                :error="form.errors.get('company')"
                @event="form.listen(form, $event)"
                :option_name="'name'"
                :option_value="'value'"
                :options="[
                    {name: 'All Companies', value: ''},
                    {name: 'Crockett', value: 'CF'},
                    {name: 'Bells', value: 'BELLS'},
                ]">
    </form-group>

    <form-group type="text"
                label="Slug"
                id="slug"
                v-model="form.slug"
                :error="form.errors.get('slug')"
                @event="form.listen(form, $event)">
    </form-group>

    <form-group type="text"
                label="Name"
                id="name"
                v-model="form.name"
                :error="form.errors.get('name')"
                @event="form.listen(form, $event)">
    </form-group>

    <form-group type="textarea"
                label="Description"
                id="description"
                v-model="form.description"
                :error="form.errors.get('description')"
                @event="form.listen(form, $event)">
    </form-group>

    <button type="button" class="button is-primary" @click="submit()">Save</button>
  </div>
</template>

<script>
import Form                           from "../../helpers/Form"
import {mapGetters}                   from "vuex"
import {CREATE_BUNDLE, UPDATE_BUNDLE} from "../../store/mutation-types"

export default {
  props: {
    bundle: {
      type: [String, Object], default: () => {
        return {
          slug: '',
          company: '',
          name: '',
          description: '',
        }
      }
    },
    create: { type: [Boolean], default: false }
  },
  data() {
    return {
      form: new Form(this, this.bundle, this.create ? CREATE_BUNDLE : UPDATE_BUNDLE)
    }
  },
  methods: {
    submit() {
      this.form.submit().then(data => {
        this.$emit('saved', data)
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// BundleForm.vue?3015226c